export default __webpack_public_path__ + "static/media/KZ.Т.12.2529 Syrdarya.12dd40e2.svg";